const firebaseConfig = {
   apiKey: "AIzaSyBvd64KekKJ3gA-5MhJ3iQ-BPdmIsEiYJA",
   authDomain: "aeromart-5f343.firebaseapp.com",
   projectId: "aeromart-5f343",
   storageBucket: "aeromart-5f343.appspot.com",
   messagingSenderId: "364208588645",
   appId: "1:364208588645:web:23d2f475c0bfbb5a65038c"
};

export default firebaseConfig